<template>
  <div v-cloak>
    <InvestorReport :cat="8000001"/>
  </div>

</template>

<script>/**
 * 公司治理-概述
 */
import InvestorReport from "./InvestorReport";

export default{
    name: 'Overview',
    components: {
      InvestorReport
    },
    data(){
      return{
        CIConData: ''
      }
    },
    created(){
      this.axios.get(this.$root.baseUrl+'/wap/aboutUs/introduction')
        .then(res=>{
          this.CIConData = res.data;
        })
        .catch(e=>{
          console.log(e)
        })
    }
  }
  document.onclick = function(e){
    document.getElementById("navLinkBox").classList.remove('active');
    document.getElementById("navLinkBox").style.transition = "0.5s";
  }
</script>

<style>
  .cIBox{
    margin: 2.1333rem 0 0;
    font-size: 1rem;
    padding: 2.1333rem 1.2rem 0;
    box-sizing: border-box;
  }
  .cIBox .cIBoxTitle{
    font-size: 1.6rem;
    font-weight: bold;
    color: #333;
    margin-bottom: 2.4666rem;
  }
  .cIBox .cIBoxTitle span{
    color: #e6e6e6;
    margin-left: 0.63333rem;
  }
  .cICon p{
    margin-bottom: 3.06667rem;
    line-height: 2rem;
    font-size: 1rem;
    color: #333;
    line-height: 2rem;
  }
  .cICon img{
    width: 100%;
  }
  [v-cloak]{ display :none }
  .homeBotTxt{
    /* position: fixed; */
    /* bottom: 1rem; */
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #333;
    /* font-weight: 100; */
    margin: 4.8rem 0 1.333rem 0;
  }
  .homeBotTxt p{
    margin-bottom: 0.5rem;
    color: #808080;
  }
  .homeBotTxt a{
    color: #bfbfbf;
    text-decoration: underline;
    font-size: 0.8rem;
    /* font-weight: 100; */
  }
  .homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
    color: #bfbfbf;
  }
</style>



// WEBPACK FOOTER //
// src/components/investor/Overview.vue